import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

// Sits inside clickable rows (the Account Setup button and section header), so the
// trigger is a plain span rather than a second button. The icon color is marked
// important because global.css paints every svg inside a sidebar menu button grey.
export const JurniCoreActionRequired = () => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span className="inline-flex shrink-0">
        <Info aria-hidden="true" className="size-3.5 !text-red-600" />
        <span className="sr-only">Activate the Jurni Core Script</span>
      </span>
    </TooltipTrigger>
    <TooltipContent className="max-w-56 text-xs">
      <p>Activate the Jurni Core Script so Jurni can collect your data.</p>
    </TooltipContent>
  </Tooltip>
);
